import StatusTag from 'components/ui/base/status/StatusTag';
import {
    MANIFEST_STATUS_MAP,
    ManifestStatusConfig,
    ManifestStatus as ManifestStatusType,
} from 'views/manifests/types/manifest-statuses';

type Props = {
    status: ManifestStatusType;
    dataTestId?: string;
};

const DEFAULT_STATUS: ManifestStatusConfig = {
    label: 'Unknown Status',
    color: 'var(--orange-6)',
};

const ManifestStatus = ({ status, dataTestId }: Props) => {
    const { label, color } = MANIFEST_STATUS_MAP[status] ?? DEFAULT_STATUS;

    return <StatusTag dataTestId={dataTestId} color={color} status={label} />;
};

export default ManifestStatus;
